import apiHandler from "../core/apiHandler";

const authUserApi = apiHandler("auth/user");

export default authUserApi;
